<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    :title="row.id ? '编辑' : '新建'"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="dialogVisible"
  >
    <div>
      <el-form ref="form" :rules="rules" :model="form" label-width="120px" size="small">
        <el-form-item label="角色名称:" prop="name">
          <el-input
            style="width: 340px;"
            placeholder="角色名称"
            v-model.trim="form.name"
            :maxlength="40"
          />
        </el-form-item>
        <el-form-item label="描述:" prop="description">
          <el-input
            style="width: 340px;"
            type="textarea"
            resize="none"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="描述"
            v-model.trim="form.description"
            :maxlength="255"
          />
        </el-form-item>
        <el-form-item label="权限:" prop="role">
          <div class="role-container" v-loading="loading">
            <el-tree
              ref="tree"
              :data="data"
              show-checkbox
              :check-strictly="!link"
              default-expand-all
              :default-checked-keys="defalutKeys"
              node-key="id"
              :props="{
                label: 'name',
                children: 'childList'
              }"
            ></el-tree>
          </div>
          <!-- <div class="check-option">
            <el-checkbox v-model="link">{{ $t('system.selectParent') }}</el-checkbox>
          </div> -->
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="edit-footer">
      <el-button size="small" @click="close">取消</el-button>
      <el-button type="primary" size="small" @click="save">保存</el-button>
    </div>
    <!-- {{defalutKeys}} -->
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: Object
  },
  data() {
    return {
      link: false,
      dialogVisible: this.visible,
      data: [],
      defalutKeys: [],
      loading: false,
      form: {
        id: '',
        name: '',
        description: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: '请填写角色名称',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('角色名称由中英文字符和数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  created() {
    if (this.row.id) {
      let params = {
        id: this.row.id
      }
      this.loading = true
      this.$ajax.get(this.$api.system.role_update_detail, params).then((res) => {
        for (const key in this.form) {
          this.form[key] = res.data[key]
        }
        this.data = res.data.menuTreeDtos
        // 权限树去掉多余权限，不做配置
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].name === '库存管理') {
            this.data.splice(i, 1)
          }
          if (this.data[i].name === '订单管理') {
            for (let j = 0; j < this.data[i].childList.length; j++) {
              if (this.data[i].childList[j].name === '待审核') {
                this.data[i].childList.splice(j, 1)
              }
              if (this.data[i].childList[j].name === '订单列表') {
                this.data[i].childList.splice(j, 1)
              }
              if (this.data[i].childList[j].name === '撤销列表') {
                this.data[i].childList.splice(j, 1)
              }
            }
          }
          if (this.data[i].name === '用户管理') {
            this.data.splice(i, 1)
          }
          if (this.data[i].name === '系统管理') {
            for (let j = 0; j < this.data[i].childList.length; j++) {
              if (this.data[i].childList[j].name === '监控日志') {
                this.data[i].childList.splice(j, 1)
              }
            }
          }
          if (this.data[i].name === '监控统计') {
            this.data.splice(i, 1)
          }
        }
        // 菜单管理为超级管理员特有，因此权限树去掉，不做配置
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].name === '系统管理') {
            for (let j = 0; j < this.data[i].childList.length; j++) {
              if (this.data[i].childList[j].name === '菜单管理') {
                this.data[i].childList.splice(j, 1)
                break
              }
            }
          }
        }
        this.defalutKeys = this.handleGetCheckList(res.data.menuTreeDtos)
        this.$nextTick(() => {
          // this.$refs.role_level.queryOption()
          this.loading = false
          this.link = true
        })
      })
    } else {
      this.loading = true
      let params = {
        roleId: ''
      }
      this.$ajax.get(this.$api.system.role_add_menu, params).then((res) => {
        this.data = res.data
        // 权限树去掉多余权限，不做配置
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].name === '库存管理') {
            this.data.splice(i, 1)
          }
          if (this.data[i].name === '订单管理') {
            for (let j = 0; j < this.data[i].childList.length; j++) {
              if (this.data[i].childList[j].name === '待审核') {
                this.data[i].childList.splice(j, 1)
              }
              if (this.data[i].childList[j].name === '订单列表') {
                this.data[i].childList.splice(j, 1)
              }
              if (this.data[i].childList[j].name === '撤销列表') {
                this.data[i].childList.splice(j, 1)
              }
            }
          }
          if (this.data[i].name === '用户管理') {
            this.data.splice(i, 1)
          }
          if (this.data[i].name === '系统管理') {
            for (let j = 0; j < this.data[i].childList.length; j++) {
              if (this.data[i].childList[j].name === '监控日志') {
                this.data[i].childList.splice(j, 1)
              }
            }
          }
          if (this.data[i].name === '监控统计') {
            this.data.splice(i, 1)
          }
        }
        // 菜单管理为超级管理员特有，因此权限树去掉，不做配置
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].name === '系统管理') {
            for (let j = 0; j < this.data[i].childList.length; j++) {
              if (this.data[i].childList[j].name === '菜单管理') {
                this.data[i].childList.splice(j, 1)
                break
              }
            }
          }
        }
        this.defalutKeys = this.handleGetCheckList(res.data)
        this.$nextTick(() => {
          this.loading = false
          this.link = true
        })
      })
    }
  },
  methods: {
    handleGetCheckList(tree) {
      let list = []
      getNode(tree, list)
      return list
      function getNode(tree, arr) {
        for (let i in tree) {
          if (tree[i].isPermission == 'Y') {
            arr.push(tree[i].id)
          }
          if (tree[i].childList && tree[i].childList.length) {
            getNode(tree[i].childList, arr)
          }
        }
      }
    },
    close() {
      this.$emit('update:visible', false)
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (this.checkForm()) {
        let menuIds = this.$refs.tree.getCheckedKeys()
        if (this.link) {
          menuIds.push(...this.$refs.tree.getHalfCheckedKeys())
        }
        menuIds = menuIds.join(',')

        let params = {
          id: this.row.id,
          name: this.form.name,
          description: this.form.description,
          menuIds: menuIds,
          state: 'Y'
        }
        let api = this.row.id ? this.$api.system.role_update : this.$api.system.role_add
        if (menuIds === '') {
          this.$message.error('至少选择一个权限')
        } else {
          this.$ajax.post(api, params).then(() => {
            this.$message.success(`${this.row.id ? '修改成功' : '新建成功'}`)
            this.close()
            this.$emit('refresh')
          })
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.edit-dialog {
  .role-container {
    width: 340px;
    border-radius: 8px;
    padding: 15px;
    border: 1px solid #eee;
    box-shadow: 0 0 -1px #ccc;
    height: 400px;
    overflow: auto;
    // &::-webkit-scrollbar {
    //   width: 3px;
    //   height: 10px;
    // }
    &::-webkit-scrollbar-track {
      background: #ffffff;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 8px;
    }
  }
}
</style>
